import { ApiResponse, Service } from '@roc/feature-app-core';

const url = {
  GET_GALLERY_USERS: '/api/v1/inspection/gallery/users',
  GET_GALLERY_FOLDERS: '/api/v1/inspection/gallery/users/{{userId}}/folders',
  GET_GALLERY_PHOTOS:
    '/api/v1/inspection/gallery/users/{{userId}}/folders/{{folderId}}/photos',
  DOWNLOAD_GALLERY_PHOTO:
    '/api/v1/inspection/gallery/users/{{userId}}/photos/{{photoUuid}}/download',
  DOWNLOAD_GALLERY_THUMBNAIL:
    '/api/v1/inspection/gallery/users/{{userId}}/photos/{{photoUuid}}/thumbnail',
  COPY_GALLERY_PHOTOS_TO_INSPECTION:
    '/api/v1/inspection/gallery/users/{{userId}}/photos/copyToInspection',
  GET_INSPECTIONS_BY_LOAN_ID: '/api/v1/inspection/loans/{{loanId}}/inspections',
};

export class GalleryService extends Service {
  getUsers(
    page: number,
    pageSize: number,
    sortBy: string = '',
    sortDir: string = '',
    filters: string = '',
    dropdownFilters: string = ''
  ): Promise<ApiResponse> {
    const params = {
      page,
      pageSize,
      sortBy,
      sortDir,
      filters,
      dropdownFilters,
    };
    return this.get(url.GET_GALLERY_USERS, params, {
      disableGlobalLoading: true,
    });
  }

  getFolders(userId: number): Promise<ApiResponse> {
    return this.get(url.GET_GALLERY_FOLDERS.replace('{{userId}}', `${userId}`));
  }

  getPhotos(userId: number, folderId: string): Promise<ApiResponse> {
    return this.get(
      url.GET_GALLERY_PHOTOS.replace('{{userId}}', `${userId}`).replace(
        '{{folderId}}',
        folderId
      )
    );
  }

  downloadPhoto(userId: number, photoUuid: string) {
    return this.get(
      url.DOWNLOAD_GALLERY_PHOTO.replace('{{userId}}', `${userId}`).replace(
        '{{photoUuid}}',
        photoUuid
      ),
      {},
      { responseType: 'blob', disableGlobalLoading: true }
    );
  }

  downloadThumbnail(userId: number, photoUuid: string) {
    return this.get(
      url.DOWNLOAD_GALLERY_THUMBNAIL.replace('{{userId}}', `${userId}`).replace(
        '{{photoUuid}}',
        photoUuid
      ),
      {},
      { responseType: 'blob', disableGlobalLoading: true }
    );
  }

  getInspectionsByLoanId(loanId: string): Promise<ApiResponse> {
    return this.get(url.GET_INSPECTIONS_BY_LOAN_ID.replace('{{loanId}}', loanId));
  }

  copyPhotosToInspection(
    userId: number,
    photoUuids: string[],
    inspectionId: number
  ): Promise<ApiResponse> {
    return this.post(
      url.COPY_GALLERY_PHOTOS_TO_INSPECTION.replace('{{userId}}', `${userId}`),
      { photoUuids, inspectionId }
    );
  }
}
